/*
 * Created by alex@hackerbay.com on 29.1.2019
 * Copyright Singularity Technologies GmbH (c) 2019. All rights reserved
 */

import * as React from "react";
import {translate} from "react-i18next";

import {Button, Col, Container, Input, Row} from "reactstrap";

class SmallDebugMenu extends React.Component {
    constructor(props){
        super(props);
    }

    render() {
        const urlIdentButtons = [];

        const urlIdents = [];
        for(const a in urlIdents) {
            urlIdentButtons.push(
                <Col key={"debug-urlIdent-button-"+a} xs={2}>
                    <Button style={{margin: "5px"}} onClick={() => {
                        this.props.updateState({urlIdent: urlIdents[a]});
                    }}>
                        {a}
                    </Button>
                </Col>

            );
        }

        return <Container>
            <Row>
                {urlIdentButtons}
            </Row>
        </Container>
    }
}

export default translate("translations")(SmallDebugMenu);